import { GridBreakpoint } from '@wix/da-shared-react/pkg/Grid';

export const SHOP_GRID_SPACING = 40;

export const SHOP_GRID_BREAKPOINTS: GridBreakpoint[] = [
  { maxWidth: 860, elementWidth: 280, elementHeight: 284 },
  {
    maxWidth: 1024,
    elementWidth: 280,
    elementHeight: 284,
    elementsPerRow: 3,
  },
  {
    maxWidth: 1366,
    elementWidth: 328,
    elementHeight: 284,
    elementsPerRow: 3,
  },
  {
    maxWidth: 1551,
    elementWidth: 328,
    elementHeight: 284,
    elementsPerRow: 4,
  },
  {
    maxWidth: 1920,
    elementWidth: 328,
    elementHeight: 284,
    elementsPerRow: 4,
  },
];
